import Map from 'ol/Map';
import Feature from 'ol/Feature';
import Draw from 'ol/interaction/Draw';
import {OSM, Vector as VectorSource} from 'ol/source';
import {Tile as TileLayer, Vector as VectorLayer} from 'ol/layer';
import {Circle as CircleStyle, Fill, Stroke, Style, RegularShape} from 'ol/style';

import {WMS} from './wms';
import {Slider} from './slider';
import {Chart} from './chart';

import {Pdf_out} from './pdf_out';
import {page_profile} from './layers';

export class Analytic{
	constructor(map){
		this.map = map;
		this.mapClick();				// activate map click listener
		this.progressbar();				// activate progressbar	
		
		this.clearButton();				// reset chart
		this.pdfButton();				// pdf create button
		
		this.addInteraction();			// add OL drawing point functionality
		this.analyticsHeaderClick();	//click on analytics header
		
		this.chart = {};
		this.chartList = [];
		let lastPoint = [];
		this.clickedCoordinates = [];		// list of clicked coordinates on map
		this.analyticsSidebarOpened = true;	//analytics sidebar status
		
		this.pdf;
		
		this.vector;
		
		this.chartOptions = {"MOISTURE_INDEX2":
								{	
									"title": "NDMI Moiusture",
									"background_color": "blue",
									"gradientColorSet": [
										["#cdcdcd", -2],
										["##670000",-0.8],
										["#ff0000", -0.24],
										["#ffff00", -0.032],
										["#00ffff", 0.032],
										["#0000ff", 0.24],
										["#0000cd", 0.8]
									]
								},
							"NDVI_FLOAT":
								{
									"title": "NDVI Vegetation",
									"background_color": "green",
									"gradientColorSet": [
										["#8f3133", 0],
										["#ffaa00",0.25],
										["#ffff00", 0.35],
										["#c5feb7", 0.55],
										["#496c42", 1]
									]
								},
							"NMDI_FLOAT":
								{
									"title": "NMDI Drought",
									"background_color": "yellow",
									"gradientColorSet": [
										["#8f3133", 0],
										["#ffaa00",0.25],
										["#ffff00", 0.35],
										["#c5feb7", 0.55],
										["#496c42", 1]
								    ]
								},
							"LST_LANDSAT_FLOAT":
								{
									"title": "LST Temperature",
									"background_color": "red",
									"gradientColorSet": [
										["#03429F", -50],
										["#F9FBFE",0],
										["#F16526", 30],
										["#5F0401", 90]
									]
								}
		};
	}
	
	// map click listener
	mapClick(){
		const that = this;
		this.map.on('click', function(evt){
			if(that.analyticStatus()){	//only on activated satellite analytic sidebar
				$("#slider-wait-chart").show();				
				//save clicked coordinates
				(that.clickedCoordinates.length < 1)? that.clickedCoordinates.push(evt.coordinate) : that.clickedCoordinates[1] = evt.coordinate;				
				that.WMS(evt.coordinate);
			}
		});
	}	
	
	// refresh time period on existing coordinates
	refreshTimePeriod(){
		for(var coord in this.clickedCoordinates){
			$("#slider-wait-chart").show();	// show slider if coordinates are available
			this.WMS(this.clickedCoordinates[coord]);
		}		
	}
	
	progressbar(){
		$("#slider-wait-chart").progressbar({
		  value:false
	  }).hide();
	}
	
	// charge WMS on click and than display data
	WMS(point){
		//TODO - pridobi datum, pripravi in nastavi ustrezne koordinate
		// dates
		const slider = new Slider();
		const date = slider.dateFromPickers();
		
		// coordinates
		//const bbox = this.BBOX(point[0]-1)+","+this.BBOX(point[1])+","+this.BBOX(point[0])+","+this.BBOX(point[1]-1);
		const bbox = [Number(this.BBOX(point[0]-1)),Number(this.BBOX(point[1])),Number(this.BBOX(point[0])),Number(this.BBOX(point[1]-1))];
		this.lastPoint = [this.BBOX(point[1]),this.BBOX(point[0])];
				
		const WMSlocal = new WMS();
		//WMSlocal.data("WMS_point",{"TIME":date, "BBOX":bbox},this.displayData.bind(this));
		
		
		const dates = date.split("/");
		
		const json = {
				  "input": {
					"bounds": {
					  "bbox": bbox,
					},					
				  },
				  "aggregation": {
					"timeRange": {
					  "from": dates[0]+"T00:00:00Z",
					  "to": dates[1]+"T23:59:59Z"
					},					
				  },				  
				}
						
		WMSlocal.jdata2(json,this.displayData.bind(this));
	}
	
	//display data handler
	displayData(data){	
		//let i = 0;
		
		// empty chartList in case of new charts build
		if(!Object.keys(this.chart).length){
			this.chartList = [];
		}
				
		for(var i in data){
			// create chart divs
			let chart_id = "wms_chart_"+i;
			$("#charts-container").append($("<div>").attr("id", chart_id));
			
			//set style
			$("#"+chart_id).css({ top: '12px', width: '100%', height: '100%', position: 'relative'});
			
			const values = this.extractSentinelChannels2(data[i]);
			
			
			if(typeof(this.chart[i]) == "undefined"){
			//if($.isEmptyObject(this.chart[i])){	
				this.chart[i] = new Chart(chart_id, values, this.chartOptions[i]);
				this.chartList.push(this.chart[i]);
			}else{				
				let d1 = this.chart[i].data;
				let d2 = values;
				
				this.chart[i].destroy();
				delete this.chart[i];
				
				for (let row in d1){
					for (let row2 in d2){
						if(d1[row]['date'].getTime() === d2[row2]['date'].getTime()){
							d1[row]['value2'] = d2[row2].value;
							break;
						}
					}
				}
				
				this.chart[i] = new Chart(chart_id, d1, this.chartOptions[i]);
				this.chartList.push(this.chart[i]);
			}
			i++;
		};
		
		$("#chart-buttons"+page_profile).show();
	}
	
	/*
	pointOnMap(color){
		console.log(this.lastPoint);
		
		let layers = this.map.getLayers().getArray();
		let layer;
				
		for(var key in layers){
			if(layers[key].id == "clickedPoints"){
				layer = layers[key];
			}
		}
		
		console.log(layers);

	}
	*/
	
	addInteraction(){
		
		let draw;
		let source = new VectorSource({wrapX: false});
		let vector = new VectorLayer({
		  source: source,
		   'displayInLayerSwitcher':false,
		   style: new Style({	// set unvisible style
			fill: new Fill({
			  color: 'rgba(255, 255, 255, 0)',
			}),
			stroke: new Stroke({
			  color: 'rgba(255, 255, 255, 0)',
			  width: 0,
			}),
		   })
		});
		
		let that = this;
		
		this.vector = vector;
		
		this.map.addLayer(vector);
		
		// define draw cursor style
		let drawStyle = new Style({
			image: 			
			//Start of the star style
			new RegularShape({
				fill: new Fill({
					color: '#3399ff'
				}),
				points: 4,
				radius1: 15,
				radius2: 1
			}),
			stroke: new Stroke({
				color: 'blue',
				width: 5
			}),
			fill: new Fill({
				color: 'green'
			})
		});
		
		// define draw		
			draw = new Draw({
			  source: source,
			  type: "Point",
			  style: drawStyle,
			});
			this.map.addInteraction(draw);
		  
		  
		// after click
		draw.on("drawend", function (event){
			if(that.analyticStatus()){
				var feature = event.feature;				
				var features = vector.getSource().getFeatures();
				let source = vector.getSource();
				let len = features.length;
				
				if(len < 1){
					let blue = new Style({
							fill: new Fill({
							  color: 'rgba(255, 255, 0, 0.2)'
							}),
							stroke: new Stroke({
							  color: '#0000cc',
							  width: 2
							}),
							image: new CircleStyle({
							  radius: 7,
							  fill: new Fill({
								color: '#3399ff'
							  })
							})
					});
					feature.setStyle(blue);
				}else{
					let red = new Style({						
							fill: new Fill({
							  color: 'rgba(255, 0, 255, 0.2)'
							}),
							stroke: new Stroke({
							  color: '#ff0000',
							  width: 2
							}),						
							image: new CircleStyle({
							  radius: 7,
							  fill: new Fill({
								color: '#ff0000'
							  })
							})
					});
					feature.setStyle(red);
				}
				
				// prevent third feature on map
				if(len > 1){
					source.removeFeature(features[len-1]);
				}
			}
		})
	};
	
	// prepare data from sentinel
	extractSentinelChannels(data){
		var values = [];
								
			for(var row in data.C0){
				values[row] = {};
				values[row]['date'] = new Date(data.C0[row].date);
				//values[row]['value'] = this.interpolateSentinelValue(data.C0[row].basicStats.mean);
				
				values[row]['value'] = (data.C0[row].basicStats.mean != "NaN")?data.C0[row].basicStats.mean:null;
			}
		
		return values;
	}
	
	// prepare data from sentinel - new API
	extractSentinelChannels2(data){
		var values = [];
		
			var dataj = JSON.parse(data);
								
			for(var row in dataj.data){
				values[row] = {};
				values[row]['date'] = new Date(dataj.data[row].interval.from);
				//values[row]['value'] = this.interpolateSentinelValue(data.C0[row].basicStats.mean);
				
				values[row]['value'] = (dataj.data[row].outputs.moisture.bands.B0.stats.mean != "NaN")?dataj.data[row].outputs.moisture.bands.B0.stats.mean:null;
			}
		
		return values;
	}
	
	interpolateSentinelValue(value){
		// sentinel converts range [-0.8, 0.8] to range [0,1]
		return (value * 1.6 / 1) - 0.8;
	}
	
	// removes charts and dot features on map (if set)
		//removeFeatures - delete dot featrues or not (default = true)
	removeChart(removeFeatures = true){
		if(!$.isEmptyObject(this.chart)){
			for(var i in this.chart){
				this.chart[i].destroy();
				delete this.chart[i];
			}
		}
				
		$("#chart-buttons0").hide();
		$("#chart-buttons1").hide();
		
		if(removeFeatures){
			this.vector.getSource().clear();
		}
	}
	
	clearButton(){
		var that = this;
		$("#chart-buttons0").hide();
		$("#chart-buttons1").hide();
		$("#clear-chart").click(function(){
			that.clickedCoordinates = [];
			that.removeChart();
			that.chartList = [];
		});
	}
	
	pdfButton(){
		var that = this;
		$("#chart-buttons0").hide();
		$("#chart-buttons1").hide();
		$("#pdf-report, #pdf-report-si, #pdf-report-it" ).click(function(){
			if(that.pdf != null){
				that.pdf = null;	//destroy if exists		
			}
			
			// get date range
			const slider = new Slider();
			const date = slider.dateFromPickers();					
			
			that.pdf = new Pdf_out(that.chartList, that.clickedCoordinates, date, $(this).data("language")).on("destroy", function(data){
				//empty chartList at PDF destruction
				//that.chartList = [];
				//that.clickedCoordinates = [];
			});
			
			//pdf.pdfOutput(that.chartList);
		});
	}
	
	
	// deprecated
	extractSentinelChannelsDeprecated(data){
		var values = {};
		for (var prop in data) {			
			if(!data.hasOwnProperty(prop)) continue;
						
			for(var row in data[prop]){
				if(typeof(values[data[prop][row].date]) === "undefined"){
					values[data[prop][row].date] = {};
				}
				values[data[prop][row].date][prop] = data[prop][row].basicStats.mean;
			}
			
		}
		
		// convert RGB to index
		for (var date in values){
			var result;
			
			if(values[date].C03 == 0){
				if(values[date].C02 == 0){
					if(values[date].C01 <= 0.5){
						result = Interpolate([0,0.5],[-0.8,-0.24],values[date].C01);
					}else{
						result = Interpolate([0.5,1],[-0.24,-0.032],values[date].C01);
					}					
				}else{
					result = Interpolate([0,1],[-0.032,0.032],values[date].C02);
				}
			}else{
				if(values[date].C02 == 0){
					if(values[date].C03 >= 0.5){
						result = Interpolate([0,0.5],[0.24,0.8],values[date].C03);
					}else{
						result = Interpolate([0.5,1],[-0.24,-0.032],values[date].C01);
					}
				}else{
				}
				
			}
		}
		
		return values;		
	}
	
	Interpolate(rgb,index, value){
		var diff_rgb = rgb[1] - rgb[0];
		var diff_index = index[1] - index[0];
		return index[0] + (value * diff_rgb / diff_index);
	}
	
	BBOX(number){
		return (Math.round(number)).toString();
	}
	
	/* analytic sidebar part */
	// map click listener
	analyticsHeaderClick(){
		const that = this;
		$("#analytics_header").on('click', function(evt){
			
			// sidebar change
			let h1 = (that.analyticsSidebarOpened)?0:"50%";
			let h2 = (that.analyticsSidebarOpened)?($(".sidebar-content").height() - (2 * $(".sidebar-header").height()) - 30):"50%";
						
			$( ".satellite_control" ).animate({
			  height:h1
			}, 500 );	

			$(".layerSwitcher").animate({
			  height:h2
			}, 500 );
			
			// checkbox change
			$("#analytics_switch").toggle();
			
			// reset charts on disable mode
			if(that.analyticsSidebarOpened){
				that.removeChart();
			}
									
			that.analyticsSidebarOpened = !that.analyticsSidebarOpened;
		});		
	}	
	
	// return analytics sidebar status
	analyticStatus(){
		return this.analyticsSidebarOpened;
	}
}